import { Grid } from '@mui/material';
import React from 'react';
import CContactCard from '../components/CContactCard';
import contacts from '../data/DataContacts';

const CTestContactPaper = contacts.map((c) => (
	<Grid item xs={12} md={6} lg={4} xl={3} key={c.email} display="flex">
		<CContactCard {...c} sx={{ height: '100%', width: '100%' }} />
	</Grid>
));

const CContactGrid = () => (
	<Grid container spacing={3} sx={{ paddingTop: '2rem' }}>
		{CTestContactPaper}
	</Grid>
);

export default CContactGrid;
